/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import {
  CircularProgress,
} from '@material-ui/core';
import { confirmSignUp } from '@webapps/business';
import {
  useMutation,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles, combine } from '@webapps/styles';
import { ROUTES_PATH } from 'config/constants';
import { useEffect } from 'react';
import Head from 'components/Head/Head';
import { linkpickTheme } from '@webapps/styles';

const cognitoErrorCodeConfirmSignUp = (code) => {
  switch (code) {
    case 'ExpiredCodeException':
      return "Votre code de confirmation n'est plus valide";
    case 'AliasExistsException':
      return 'Un compte avec ces identifiants existe déjà';
    case 'CodeMismatchException':
      return 'Votre code de confirmation est invalide';
    case 'InternalErrorException':
      return 'Problème de service, merci de réessayer plus tard';
    case 'InvalidLambdaResponseException':
      return 'Problème de service, merci de réessayer plus tard.';
    case 'InvalidParameterException':
      return 'Problème de service, merci de réessayer plus tard.';
    case 'LimitExceededException':
      return "La limite d'essai a été dépassée, merci de réessayer plus tard.";
    case 'NotAuthorizedException':
      return "Vous n'etes pas autorisé à faire cet action";
    case 'ResourceNotFoundException':
      return "Votre compte n'est pas trouvé";
    case 'TooManyFailedAttemptsException':
      return "La limite d'essai a été dépassée, merci de réessayer plus tard.";
    case 'TooManyRequestsException':
      return "La limite d'essai a été dépassée, merci de réessayer plus tard.";
    case 'UnexpectedLambdaException':
      return 'Problème de service, merci de réessayer plus tard.';
    case 'UserLambdaValidationException':
      return 'Problème de service, merci de réessayer plus tard.';
    case 'UserNotFoundException':
      return "Votre compte n'est pas trouvé";
    default:
      return 'Veuillez contacter le service technique support-technique@linkpick.fr';
  }
};

const ConfirmSignUp = () => {
  const { classes } = useStyles(styles);
  const { push, searchParams } = useRouter();

  const params = linkpickTheme.params;

  const { confirmation_code, user_name } = searchParams;

  const {
    error: errorForgotConfirm,
    isLoading: isLoadingConfirm,
    isSuccess: isSuccessConfirm,
    mutate: mutateConfirmSignUp,
  } = useMutation(confirmSignUp);

  useEffect(() => {
    if (user_name && confirmation_code) {
      mutateConfirmSignUp({
        code: confirmation_code,
        username: user_name,
      });
    }
    // eslint-disable-next-line
  }, [user_name, confirmation_code]);

  useEffect(() => {
    if (isSuccessConfirm) {
      setTimeout(() => {
        push(ROUTES_PATH.SIGN_IN);
      }, 3000);
    }
  }, [isSuccessConfirm]);

  const goToSignin = () => {
    push(ROUTES_PATH.SIGN_IN);
  };

  const goToHome = () => {
    window.location.href = 'https://linkpick.fr/';
  };

  console.log(params)

  return (
    <>
      <Head 
        subtitle="Vérification de votre compte Linkpick." 
        title="Confirmation d'inscription" 
      />
      <div className={classes["container"]}>
        <div className={classes["mainContent"]}>
          <div className={classes["confirmationCard"]}>
            <img className={classes["logoImage"]} src="https://framerusercontent.com/images/qqOrGy2I24bIEV6YBsPwmfUWJ7w.png" srcSet="https://framerusercontent.com/images/qqOrGy2I24bIEV6YBsPwmfUWJ7w.png?scale-down-to=512 512w,https://framerusercontent.com/images/qqOrGy2I24bIEV6YBsPwmfUWJ7w.png?scale-down-to=1024 1024w,https://framerusercontent.com/images/qqOrGy2I24bIEV6YBsPwmfUWJ7w.png?scale-down-to=2048 2048w,https://framerusercontent.com/images/qqOrGy2I24bIEV6YBsPwmfUWJ7w.png?scale-down-to=4096 4096w,https://framerusercontent.com/images/qqOrGy2I24bIEV6YBsPwmfUWJ7w.png 4837w" sizes="254px" alt="" />
            <div className={classes["messageContainer"]}>
              <div className={classes["messageContent"]}>
                <img className={classes["confirmationIcon"]} src="https://framerusercontent.com/images/2IUFuMz7NRd8TtkGnEPIR8Va5Y.png" srcSet="https://framerusercontent.com/images/2IUFuMz7NRd8TtkGnEPIR8Va5Y.png?scale-down-to=512 512w,https://framerusercontent.com/images/2IUFuMz7NRd8TtkGnEPIR8Va5Y.png?scale-down-to=1024 1024w,https://framerusercontent.com/images/2IUFuMz7NRd8TtkGnEPIR8Va5Y.png?scale-down-to=2048 2048w,https://framerusercontent.com/images/2IUFuMz7NRd8TtkGnEPIR8Va5Y.png?scale-down-to=4096 4096w,https://framerusercontent.com/images/2IUFuMz7NRd8TtkGnEPIR8Va5Y.png 4479w" sizes="177px" alt="" />
                {isLoadingConfirm && (
                  <div className={classes["messageText"]} style={{ textAlign: 'center' }}>
                    <CircularProgress size={24} style={{ color: params.colors.bleuElectrique, marginBottom: 16 }} />
                    <br />Vérification en cours...
                  </div>
                )}
                {errorForgotConfirm && (
                  <div className={classes["messageText"]} style={{ color: params.colors.roseElectrique, textAlign: 'center', background: params.colors.rosePoudre, borderRadius: 8, padding: 8, margin: 8 }}>
                    {cognitoErrorCodeConfirmSignUp(errorForgotConfirm?.code)}
                  </div>
                )}
                {isSuccessConfirm && (
                  <>
                    <div className={classes["successTitle"]}>Votre compte est confirmé ✔️</div>
                    <div className={classes["messageText"]}>Nous vous remercions pour votre inscription !<br /> Vous allez être redirigé automatiquement vers la page de connexion.</div>
                  </>
                )}
                {!(isLoadingConfirm || errorForgotConfirm || isSuccessConfirm) && (
                  <>
                    <div className={classes["successTitle"]}>Confirmation de votre inscription en cours...</div>
                  </>
                )}
              </div>
            </div>
            <div className={classes["contactInfo"]}>
              <div className={classes["contactText"]}>L'équipe de Linkpick</div>
              <div className={classes["contactText"]}>Une question ? Contactez-nous par mail via</div>
              <a href="mailto:support@linkpick.fr" target="_blank" rel="noopener noreferrer" className={classes["emailLink"]}>support@linkpick.fr</a>
            </div>
          </div>
        </div>
        <div className={classes["footer"]}>
          <div className={classes["socialIcons"]}>
            <img className={classes["socialIcon"]} src="https://framerusercontent.com/images/bzr63cJ2sIt7Z2HzxlxZ5WSsw.svg" alt="" />
            <img className={classes["socialIconSmall"]} src="https://framerusercontent.com/images/Ot66JIXIVQcHr3vC28N409zI.svg" alt="" />
            <img className={classes["socialIconSmall"]} src="https://framerusercontent.com/images/eUcrvlJJNPNgYCWTeq2Ahemhkk.svg" alt="" />
            <img className={classes["socialIconSmall"]} src="https://framerusercontent.com/images/kRM8zjUiTG7TPQWV0NGw34qxFEI.svg" alt="" />
          </div>
          <div className={classes["footerInfo"]}>
            <div className={classes["footerText"]}>© 2025 Linkpick. Tous les droits sont réservés</div>
            <div className={classes["footerText"]}>195 allée du cagnard, 13004 Marseille, France</div>
          </div>
        </div>
      </div>
    </>
  );
};

const styles = () => {
  const { fontSizes2, gap, padding, colors } = linkpickTheme.params;
  return {
    container: {
      alignContent: "center",
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      position: "relative",
      width: "100%",
      placeItems: "center",
      backgroundColor: colors.blancGlacial,
    },
    mainContent: {
      alignContent: "center",
      display: "flex",
      flexDirection: "row",
      flex: "1",
      position: "relative",
      ...combine(gap.s),
      placeItems: "center",
      padding: "20px 0",
    },
    confirmationCard: {
      alignItems: "center",
      backgroundColor: colors.blanc,
      borderRadius: "36px",
      display: "flex",
      flexDirection: "column",
      width: "100%",
      flexGrow: "0.3",
      "@media only screen and (max-width:810px)": {
        flexGrow: "1",
      },
      height: "min-content",
      justifyContent: "flex-start",
      ...combine(padding.xxl, gap.xxl),
      position: "relative",
      overflow: "visible",
      margin: "0 20px",
    },
    logoImage: {
      aspectRatio: "4.38134 / 1",
      position: "relative",
      width: "254px",
      overflow: "visible",
    },
    messageContainer: {
      alignItems: "center",
      backgroundColor: colors.blancGlacial,
      borderRadius: "20px",
      display: "flex",
      flexDirection: "column",
      height: "min-content",
      justifyContent: "flex-start",
      ...combine(padding.xxl, gap.xxl),
      position: "relative",
      width: "100%",
      overflow: "visible",
    },
    messageContent: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      height: "min-content",
      justifyContent: "flex-start",
      position: "relative",
      width: "100%",
      ...combine(gap.s),
      overflow: "hidden",
    },
    confirmationIcon: {
      aspectRatio: "2.15544 / 1",
      position: "relative",
      width: "177px",
      overflow: "visible",
    },
    successTitle: {
      fontFamily: "Montserrat, sans-serif",
      ...combine(fontSizes2.h1),
      fontWeight: 600,
      textAlign: "center",
      color: colors.bleuMarine,
      width: "100%",
    },
    messageText: {
      fontFamily: "Roboto, sans-serif",
      ...combine(fontSizes2.body),
      color: colors.bleuArdoise,
      textAlign: "center",
      width: "100%",
    },
    contactInfo: {
      alignContent: "center",
      display: "flex",
      flexDirection: "column",
      height: "min-content",
      position: "relative",
      width: "100%",
      ...combine(gap.xs),
      overflow: "hidden",
      placeItems: "center",
    },
    contactText: {
      fontFamily: "Roboto, sans-serif",
      ...combine(fontSizes2.body),
      color: colors.bleuArdoise,
      textAlign: "center",
    },
    emailLink: {
      fontFamily: "Roboto, sans-serif",
      ...combine(fontSizes2.body),
      color: colors.bleuElectrique,
      textAlign: "center",
      textDecoration: "underline",
    },
    footer: {
      alignItems: "center",
      backgroundColor: colors.bleuMarine,
      display: "flex",
      flexDirection: "column",
      height: "min-content",
      justifyContent: "flex-start",
      ...combine(padding.xxl, gap.xxl),
      position: "relative",
      width: "100%",
      overflow: "visible",
    },
    socialIcons: {
      alignItems: "center",
      borderRadius: padding.s['@media only screen and (max-width:1920px)'].padding,
      display: "flex",
      flexDirection: "row",
      height: "min-content",
      justifyContent: "flex-start",
      position: "relative",
      width: "min-content",
      ...combine(gap.s),
      overflow: "hidden",
    },
    socialIcon: {
      aspectRatio: "1 / 1",
      position: "relative",
      width: "25px",
      overflow: "hidden",
    },
    socialIconSmall: {
      aspectRatio: "1 / 1",
      position: "relative",
      width: "24px",
      overflow: "hidden",
    },
    footerInfo: {
      alignContent: "center",
      display: "flex",
      flexDirection: "column",
      height: "min-content",
      position: "relative",
      width: "100%",
      ...combine(gap.xs),
      overflow: "hidden",
      placeItems: "center",
    },
    footerText: {
      fontFamily: "Roboto, sans-serif",
      ...combine(fontSizes2.body),
      color: colors.blanc,
      textAlign: "center",
    },
  };
};

export default ConfirmSignUp; 